<img
    class="tw-top-6 tw-absolute tw-cursor-pointer xl:tw-w-[27px]"
    [ngClass]="
        modalData.isMobileView ? 'tw-left-[21.50rem]' : 'tw-left-[24rem]'
    "
    src="../../../assets/images/announcement-close.svg"
    (click)="activeModal.dismiss()"
    alt="Close Announcement"
/>
<div class="tw-pt-14 tw-pb-5 tw-pl-2.5 tw-pr-2.5">
    <div
        class="modal-header tw-flex tw-flex-wrap tw-text-[24px] tw-font-semibold tw-border-b-0 tw-pb-0 tw-break-words tw-w-[93%]"
    >
        <h1 class="tw-font-semibold">
            {{ modalData?.event?.title }}
            <br />
            &nbsp;- {{ modalData?.event?.category }}
        </h1>
    </div>
    <div class="modal-body tw-pt-0">
        <div class="tw-mb-1.5 tw-text-base tw-font-semibold">
            {{ "LNDP_CALENDAR.SUBCATEGORY" | translate }}:
            {{ modalData?.event?.subcategory }}
        </div>
        <div class="tw-mb-1.5 tw-text-base tw-font-semibold">
            {{ "COMMON.DATE" | translate }}:
            {{ modalData?.event?.date }}
        </div>
        <div class="tw-mb-1.5 tw-text-base tw-font-semibold">
            {{ "LNDP_CALENDAR.TIME" | translate }}:
            {{ modalData?.event?.startTime }} -
            {{ modalData?.event?.endTime }}
        </div>
        <div class="tw-mb-1.5 tw-text-base tw-font-semibold">
            {{ "LNDP_CALENDAR.VENUE" | translate }}:
            {{ modalData?.event?.venue }}
        </div>
        <div class="tw-mb-1.5 tw-text-base tw-font-semibold">
            {{ "LNDP_CALENDAR.EVENT_TYPE" | translate }}:
            {{ modalData?.event?.meta?.mode }}
        </div>
        <div class="tw-mb-3.5 tw-text-base tw-font-semibold">
            {{ "LNDP_CALENDAR.DESCRIPTION" | translate }}:
        </div>
        <p
            class="tw-text-base tw-font-medium tw-text-[#8d8d8d] tw-break-words tw-mb-[38px] tw-max-w-[369px]"
        >
            {{ modalData?.event?.eventDescription }}
        </p>
        <p
            class="tw-text-base tw-font-medium tw-text-[#eb5544]"
            *ngIf="modalData?.event?.eventExpired"
        >
            {{ "LNDP_CALENDAR.EVENT_EXPIRED_NOTICE" | translate }}
        </p>
        <button
            [disabled]="
                modalData?.event?.eventExpired || !modalData?.event?.link
            "
            class="tw-text-white tw-text-lg tw-font-semibold tw-py-2 tw-whitespace-nowrap tw-rounded-[3rem] tw-px-4 tw-block tw-m-auto"
            [ngClass]="
                modalData?.event?.eventExpired || !modalData?.event?.link
                    ? 'tw-bg-slate-300'
                    : 'tw-bg-[#f5c146]'
            "
            (click)="onSubmit(modalData?.event?.link)"
        >
            {{ "LNDP_CALENDAR.REGISTER_HERE" | translate }}
        </button>
    </div>
</div>
